import usePanel from '@databases/panel/usePanel';

import { useViewUiState } from './useViewUiState';

const useViewPanel = () => {
  const { hidePanel } = usePanel();
  const { setActivePanelSetting } = useViewUiState();

  const closeViewSettingsPanel = () => {
    hidePanel();
    setActivePanelSetting(null);
  };

  return {
    closeViewSettingsPanel,
  };
};

export default useViewPanel;
